import React from 'react';
import { Box, Flex, Text } from '@ascension/web';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import SortingComponent from '@components/SortingComponent/SortingComponent';
import SearchComponent from '@components/SearchComponent/SearchComponent';

const useStyles = makeStyles((theme) => createStyles({
	sortingDropdown: {
		'& > div > div > div > div > div:first-child': {
			borderStyle: 'unset',
		},
	},
	helperText: {
		color: theme.palette.grey[600],
		fontSize: '0.75rem',
		fontWeight: 700,
		letterSpacing: '1px',
		paddingBottom: theme.spacing(.5),
	},
}));

const sortOptions = [
	{ label: 'TEMPLATE NAME' },
	{ value: 'name:asc', label: 'TEMPLATE NAME A-Z' },
	{ value: 'name:desc', label: 'TEMPLATE NAME Z-A' },
	{ label: 'SURGEON' },
	{ value: 'lastName:asc,firstName:asc,name:asc', label: 'SURGEON A-Z' },
	{ value: 'lastName:desc,firstName:asc,name:asc', label: 'SURGEON Z-A' },
	{ label: 'PROCEDURE' },
	{ value: 'procedureName:asc,name:asc', label: 'PROCEDURE NAME A-Z' },
	{ value: 'procedureName:desc,name:asc', label: 'PROCEDURE NAME Z-A' },
	{ label: 'DATE CREATED' },
	{ value: 'dateCreated:asc,name:asc', label: 'OLDEST' },
	{ value: 'dateCreated:desc,name:asc', label: 'NEWEST' }
];

const TemplateFilters = ({ surgeonFilter: SurgeonFilter }: {surgeonFilter: React.ElementType}) => {
	const classes = useStyles();
	return (
		<>
			<Flex mb={10} width={1} flexDirection="column">
				<Box flex="1" width={1}>
					<SearchComponent hasMaxValue={true} placeholder="Search by Keyword"/>
				</Box>
				<Box>
					<Text className={classes.helperText}>
						50 characters max
					</Text>
				</Box>
			</Flex>
			<Flex width={1} style={{ gap: '16px' }}>
				<Box flex="1 1 50%">
					<SurgeonFilter borderless={false} label="Surgeons"/>
				</Box>
				<Box flex="1 1 50%" className={classes.sortingDropdown}>
					<SortingComponent options={sortOptions} borderless={false} />
				</Box>
			</Flex>
		</>
	);
};

export default TemplateFilters;
